import { Scales24Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return <Scales24Filled primaryFill={"rgba(115, 118, 225, 1)"} aria-hidden="true" aria-label="Answer logo" />;
};
